import React, { createContext, PropsWithChildren } from "react";
import Script from "next/script";

interface Iframely {
  load(containerElement?: HTMLElement, url?: string): void;
  load(linkElement?: HTMLAnchorElement): void;
  load(): void;
}

declare global {
  // Augment the globalThis type to include the iframely instance
  var iframely: Iframely | undefined;
}

export const IframelyContext = createContext<Iframely>({
  load(element?: HTMLElement, url?: string) {
    globalThis.iframely?.load(element, url);
  },
});

export const IframelyProvider: React.FC<PropsWithChildren> = ({
  children,
}) => (
  <>
    <Script
      src={`https://cdn.iframe.ly/embed.js?key=${process.env.iframelyApiKey}`}
      async
    />
    {children}
  </>
);
